<template>
  <div class="container">
    <LoadingIndicator v-if="loading" class="loading-spinner" />
    <template v-else>
      <img :src="arcaneLogo" alt="Arcane Logo" class="logo" />
      <BbBtn color="#6222e3" class="login-button" @click="login">{{ t('authentication.login') }}</BbBtn>
    </template>
  </div>
</template>

<script>
import { useAuth0 } from '@auth0/auth0-vue';
import { onMounted, ref } from 'vue';
import arcaneLogo from '~/assets/svg/Arcane-logo.svg';
import LoadingIndicator from '~/components/common/LoadingIndicator';
import auth0Client from '~/plugins/authClient';
import { Routes } from '~/constants/routes';
import { useI18n } from 'vue-i18n';

export default {
  components: {
    LoadingIndicator,
  },

  beforeRouteEnter(to, from, next) {
    // redirect to "home" if user is already authenticated

    const params = new URLSearchParams(window.location.search);
    const organization = params.get('organization');
    const invitation = params.get('invitation');

    // accept user invitation flow
    if (organization && invitation) {
      return auth0Client.loginWithRedirect({ params: { organization, invitation } });
    }

    const redirectCallback = localStorage.getItem('auth.redirect');
    if (redirectCallback && auth0Client.isAuthenticated.value) {
      console.log('in redirect callback localstorage');
      localStorage.removeItem('auth.redirect');
      return next(redirectCallback);
    }

    if (auth0Client && auth0Client.isAuthenticated && auth0Client.isAuthenticated.value) {
      next({ name: Routes.Conversation.name });
    } else {
      next();
    }
  },

  setup() {
    const { loginWithRedirect } = useAuth0();

    const loading = ref(false);
    const { t } = useI18n();

    const login = () => {
      loginWithRedirect();
    };

    onMounted(() => {
      const params = new URLSearchParams(window.location.search);
      const organization = params.get('organization');
      const invitation = params.get('invitation');
      loading.value = !!organization && !!invitation;
    });

    return {
      arcaneLogo,
      loading,
      login,
      t,
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .logo {
    width: 200px;
    height: auto;
  }

  .login-button {
    margin-top: $bb-spacing-24;
  }
}
</style>

<style lang="scss">
* {
  box-sizing: border-box;
}
</style>
